<div class="relative">
    <div class="absolute">
        <mat-spinner id="bg-circle" diameter="128" customSpinner [color]="bgColor" [value]="100" mode="determinate"></mat-spinner>
    </div>
    <div>
        <mat-spinner id="main-circle" diameter="128" customSpinner [color]="color" [value]="actualValue" mode="determinate"></mat-spinner>
    </div>
</div>